import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

export const useSectionEventOnViewportEntrance = ({
  sectionName,
  page,
  position,
}: {
  sectionName: string;
  page: string;
  position?: number;
}) => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.3 });
  const { trackEvent } = useAnalyticsContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies:  justification: inView is the only dependency
  useEffect(() => {
    if (inView) {
      trackEvent('page.section.viewed', {
        section_name: sectionName,
        page,
        ...(position ? { section_position: position } : {}),
      });
    }
  }, [inView]);

  return ref;
};
